"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
//@ts-nocheck
/**
 * pageopt
 */
var wconfig = require('../../config/web.js');
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var delayquote_1 = require("../../src/modules/delayquote");
var objs = {};
var prefix = ["", "HGT", "GGTH", "SGT", "GGTS"];
function zjlx_datafmt(data, sc, fix) {
    if (sc === void 0) { sc = true; }
    if (fix === void 0) { fix = '元'; }
    return fieldtools_1["default"].fieldfmt(data, { zoom: 4, showcolor: sc, num: 2, fix: fix });
}
function getlszeData(item) {
    var result = '-';
    var res = '';
    if (item.hk2sz.status == '1' || item.hk2sz.status == '2') {
        result = "盘后更新";
    }
    else {
        var date = item.hk2sh.date2.replace(/-/g, '');
        if (item.hk2sz.buySellAmt && item.hk2sh.buySellAmt && date == item.hk2sh.buySellAmtDate) {
            res = item.hk2sz.buySellAmt + item.hk2sh.buySellAmt;
            result = "" + zjlx_datafmt(res, false);
        }
        else {
            result = '-';
        }
    }
    return result;
}
function getcjzeData(item) {
    var result = '-';
    if (item.status != 4) {
        var date = item.date2.replace(/-/g, '');
        if (item.status == 3) {
            if (item.buySellAmt && item.buySellAmt >= 0 && date == item.buySellAmtDate) {
                result = "" + zjlx_datafmt(item.buySellAmt, false);
            }
            else {
                result = '-';
            }
        }
    }
    return result;
}
function getsyedData(listType) {
    var result = '-';
    if (listType.status == 3) {
        if (listType.amtStatus == 1) {
            result = listType.dayAmtRemain == 0 ? "额度充足" : zjlx_datafmt(listType.dayAmtRemain, false);
        }
        else {
            result = zjlx_datafmt(listType.dayAmtRemain, false);
        }
    }
    else {
        switch (listType.amtStatus) {
            case 1:
                result = "额度充足";
                break;
            case 2:
                result = listType.dayAmtRemain ? zjlx_datafmt(listType.dayAmtRemain, false) : "-";
                break;
            case 3:
                result = '当日额度耗尽';
                break;
        }
    }
    return result;
}
var mapping = {
    "f2": "zxj",
    "f3": "zdf",
    "f127": "zdf",
    "f109": "zdf",
    "f160": "zdf",
    "f12": "code",
    "f14": "name",
    "f62": "zlje",
    "f184": "zljzb",
    "f66": "cddje",
    "f69": "cddjzb",
    "f72": "ddje",
    "f75": "ddjzb",
    "f78": "zdje",
    "f81": "zdjzb",
    "f84": "xdje",
    "f87": "xdjzb",
    "f267": "zlje",
    "f268": "zljzb",
    "f269": "cddje",
    "f270": "cddjzb",
    "f271": "ddje",
    "f272": "ddjzb",
    "f273": "zdje",
    "f274": "zdjzb",
    "f275": "xdje",
    "f276": "xdjzb",
    "f164": "zlje",
    "f165": "zljzb",
    "f166": "cddje",
    "f167": "cddjzb",
    "f168": "ddje",
    "f169": "ddjzb",
    "f170": "zdje",
    "f171": "zdjzb",
    "f172": "xdje",
    "f173": "xdjzb",
    "f174": "zlje",
    "f175": "zljzb",
    "f176": "cddje",
    "f177": "cddjzb",
    "f178": "ddje",
    "f179": "ddjzb",
    "f180": "zdje",
    "f181": "zdjzb",
    "f182": "xdje",
    "f183": "xdjzb",
    "f205": "zdcode",
    "f204": "zdname",
    "f258": "zdcode",
    "f257": "zdname",
    "f261": "zdcode",
    "f260": "zdname",
    "f225": "zlpm1",
    "f263": "zlpm5",
    "f264": "zlpm10"
};
$(".jgcx_btn").on("click", function () {
    event.preventDefault();
    var s = $('#gdmc_txt').val().toString().trim();
    if (s == '' || s == '输入机构关键词') {
        alert("请输入要查询的机构关键词！");
        return false;
    }
    window.open('/hsgtcg/InstitutionQuery.html?kwd=' + encodeURIComponent(s));
});
$("#jgcx_hsgtV2").on("click", function () {
    event.preventDefault();
    var s = $('#gdmc_txt').val().toString().trim();
    if (s == '' || s == '输入机构关键词') {
        alert("请输入要查询的机构关键词！");
        return false;
    }
    window.open('/hsgtV2/hsgtDetail/jgph.html?kwd=' + encodeURIComponent(s));
});
$("#gdmc_txt").on("focus", function () {
    if ($(this).val() == "输入机构关键词") {
        $(this).val("");
    }
});
$("#gdmc_txt").on("blur", function () {
    if ($(this).val() == "") {
        $(this).val("输入机构关键词");
    }
});
function getStatus(tag) {
    var res = '-';
    switch (tag) {
        case 1:
            res = '交易中';
            break;
        case 2:
            res = '额度已满';
            break;
        case 3:
            res = '收盘';
            break;
        case 4:
            res = '休市';
            break;
        default:
            res = '-';
            break;
    }
    return res;
}
function getamtStatu(item, listType) {
    var result = '<td>-</td><td>-</td><td>-</td>';
    var northstatus = '';
    var yyed = '';
    var zjye = '';
    if (listType.status != 4) {
        // $('.Remain_quota').html("成交净买额")
        // $('.lzg_yyed').html("总成交额")
        // $('.zdf_zjye').html("当日资金余额")
        // northstatus=(listType.status=="1"||listType.status=="2")?"盘后更新":listType.netBuyAmt?zjlx_datafmt(listType.netBuyAmt):"-"
        northstatus = "" + ((item.f128 && item.f140) ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f140) + "\">" + item.f128 + "</a>" : '-');
        yyed = (listType.status == "1" || listType.status == "2") ? "盘后更新" : listType.buySellAmt ? zjlx_datafmt(listType.buySellAmt) : "-";
        if (listType.status == 3) {
            if (listType.amtStatus == 1) {
                zjye = listType.dayAmtRemain == 0 ? "额度充足" : zjlx_datafmt(listType.dayAmtRemain, false);
            }
            else {
                zjye = zjlx_datafmt(listType.dayAmtRemain, false);
            }
        }
        else {
            switch (listType.amtStatus) {
                case 1:
                    zjye = "额度充足";
                    break;
                case 2:
                    zjye = listType.dayAmtRemain ? zjlx_datafmt(listType.dayAmtRemain, false) : "-";
                    break;
                case 3:
                    zjye = '当日额度耗尽';
                    break;
            }
        }
        result = "<td>" + northstatus + "</td><td>" + yyed + "</td><td>" + zjye + "</td>";
    }
    else {
        result = '<td>-</td><td>-</td><td>-</td>';
    }
    return result;
}
function getamtStatu_nx(item, listType) {
    var result = '<td>-</td><td>-</td><td>-</td>';
    var southstatus = '';
    var jme = '';
    var cje = '';
    if (listType.status != 4) {
        jme = zjlx_datafmt(listType.netBuyAmt);
        cje = "<span class=\"red\">" + (listType.buySellAmt ? zjlx_datafmt(listType.buySellAmt) : "-") + "</span>";
        if (listType.status == 3) {
            if (listType.amtStatus == 1) {
                southstatus = listType.dayAmtRemain == 0 ? "额度充足" : zjlx_datafmt(listType.dayAmtRemain, false);
            }
            else {
                southstatus = zjlx_datafmt(listType.dayAmtRemain, false);
            }
        }
        else {
            switch (listType.amtStatus) {
                case 1:
                    southstatus = "额度充足";
                    break;
                case 2:
                    southstatus = zjlx_datafmt(listType.dayAmtRemain, false);
                    break;
                case 3:
                    southstatus = '当日额度耗尽';
                    break;
            }
        }
        result = "<td>" + jme + "</td><td>" + cje + "</td><td>" + southstatus + "</td>";
    }
    return result;
}
var pageopt = {
    urlkeyvalues: {
        pagenumber: "pageNumber",
        pagesize: "pageSize",
        sortname: "sortColumns",
        sortorder: "sortTypes"
    },
    statvalues: {
        "1": "f12,f14,f2,f3,f62,f184,f66,f69,f72,f75,f78,f81,f84,f87,f204,f205,f124,f1,f13",
        "3": "f12,f14,f2,f127,f267,f268,f269,f270,f271,f272,f273,f274,f275,f276,f257,f258,f124,f1,f13",
        "5": "f12,f14,f2,f109,f164,f165,f166,f167,f168,f169,f170,f171,f172,f173,f257,f258,f124,f1,f13",
        "10": "f12,f14,f2,f160,f174,f175,f176,f177,f178,f179,f180,f181,f182,f183,f260,f261,f124,f1,f13"
    },
    sdate: moment().add({ "months": -3 }).format("YYYY-MM-DD"),
    bkvalues: {
        "hy": "m:90 t:2",
        "gn": "m:90 t:3",
        "dy": "m:90 t:1"
    },
    upquerystat: function (options, queryparams) {
        if (queryparams.data && queryparams.data.fid && queryparams.data.fields) {
            Object.keys(mapping).forEach(function (key) {
                if (queryparams.data.fid == mapping[key] && queryparams.data.fields.indexOf(key + ',') > -1)
                    queryparams.data.fid = key;
            });
        }
        return queryparams;
    },
    ///资金流向排行数据配置
    zjlx_datafmt: function (data, sc, fix, zoom) {
        if (sc === void 0) { sc = true; }
        if (fix === void 0) { fix = '元'; }
        if (zoom === void 0) { zoom = 4; }
        return fieldtools_1["default"].fieldfmt(data, { zoom: zoom, showcolor: sc, num: 2, fix: fix });
    },
    load_zjlx_table: function () {
        var nx_sjed = fieldtools_1["default"].getUrlParam("nx_sjed");
        var _this = this;
        var url = wconfig.getWebPath('quoteurl') + "api/qt/kamt/get";
        var data = {
            fields1: "f1,f2,f3,f4",
            fields2: "f51,f52,f53,f54,f56,f60,f61,f62,f63,f65,f66",
            ut: "fa5fd1943c7b386f172d6893dbfba10b",
        };
        var arr = [];
        for (var k in data) {
            arr.push(k + "=" + data[k]);
        }
        $.ajax({
            type: "get",
            url: url + "?" + arr.join("&"),
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (json) {
                var list = json === null || json === void 0 ? void 0 : json.data;
                // getAllcjzeData(list)
                var hk_html = '', i = 0;
                var north_html = '';
                var arr = ['#28003707_12_2', '#mk0144_12', '#28013804_12_3', '#mk0146_12'];
                _this.load_hq_scx().then(function (jsonRes) {
                    var _a;
                    var res = (_a = jsonRes === null || jsonRes === void 0 ? void 0 : jsonRes.data) === null || _a === void 0 ? void 0 : _a.diff;
                    $("#north_cjze").text(getlszeData(list));
                    for (i = 0; i < 4; i++) {
                        var item = res[i];
                        var name_1 = item.f14;
                        var BOARD_TYPE = void 0;
                        var code = void 0;
                        var listType = void 0;
                        if (name_1 == '沪股通' || name_1 == '深股通') {
                            if (name_1 == '沪股通') {
                                name_1 = '港>沪';
                                BOARD_TYPE = '陆股通';
                                listType = list.hk2sh;
                                code = '000001';
                                $("#updateTime_north_lsze").text(listType.date2);
                                // 成交总额删除
                                $("#north_h_cjze").html((listType.status == "1" || listType.status == "2") ? "盘后更新" : listType.buySellAmt ? zjlx_datafmt(listType.buySellAmt, false) : "-");
                                $("#north_h_syed").html(getsyedData(listType));
                                $("#north_h_lzg").html("<span>" + ((item.f128 && item.f140) ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f140) + "\">" + item.f128 + "</a>" : '-') + "</span>");
                            }
                            else if (name_1 == '深股通') {
                                name_1 = '港>深';
                                BOARD_TYPE = '陆股通';
                                code = '399001';
                                listType = list.hk2sz;
                                $("#north_s_cjze").html((listType.status == "1" || listType.status == "2") ? "盘后更新" : listType.buySellAmt ? zjlx_datafmt(listType.buySellAmt, false) : "-");
                                $("#north_s_syed").html(getsyedData(listType));
                                $("#north_s_lzg").html("<span>" + ((item.f128 && item.f140) ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f140) + "\">" + item.f128 + "</a>" : '-') + "</span>");
                            }
                            var zs_link = code == "HSI" ? "//quote.eastmoney.com/unify/r/100.HSI" : "//quote.eastmoney.com/zs" + code + ".html";
                            var zsarr = _this.getzs_info(res, code);
                            north_html += "<tr " + (i % 2 == 1 ? "class='bbLightBlue'" : "") + ">\n                            " + (i == 0 ? '<td rowspan="2" class="bbLightBlue">' + fieldtools_1["default"].strformat(BOARD_TYPE) + '</td>' : '') + "\n                            <td><a href=\"//quote.eastmoney.com/center/list.html" + arr[i] + "\">" + name_1 + "</a></td>\n                            <td>" + getStatus(listType.status) + "</td>";
                            if (listType.status != 4) {
                                north_html += getamtStatu(item, listType) + "\n                                <td><span class=\"red\">" + fieldtools_1["default"].fieldfmt(item.f104, { num: 0 }) + "</span></td>\n                                <td>" + fieldtools_1["default"].fieldfmt(item.f106, { num: 0 }) + "</td>\n                                <td><span class=\"green\">" + fieldtools_1["default"].fieldfmt(item.f105, { num: 0 }) + "</span></td>\n                                <td clsss=\"\"><a href=\"" + zs_link + "\">" + zsarr[0] + "</a></td>\n                                <td>" + fieldtools_1["default"].fieldfmt(zsarr[1], { showcolor: true, fix: '%', num: 2 }) + "</td>\n                                </tr>";
                            }
                            else { //休市时资金流数据置空
                                north_html += "<td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td clsss=\"\"><a href=\"" + zs_link + "\">" + zsarr[0] + "</a></td>\n                                    <td>" + fieldtools_1["default"].fieldfmt(zsarr[1], { showcolor: true, fix: '%', num: 2 }) + "</td>\n                                    </tr>";
                            }
                        }
                        else {
                            if (name_1 == '港股通(沪)') {
                                name_1 = '沪>港';
                                BOARD_TYPE = '港股通';
                                code = 'HSI';
                                listType = list.sh2hk;
                            }
                            else if (name_1 == '港股通(深)') {
                                name_1 = '深>港';
                                BOARD_TYPE = '港股通';
                                code = 'HSI';
                                listType = list.sz2hk;
                            }
                            var zs_link = code == "HSI" ? "//quote.eastmoney.com/unify/r/100.HSI" : "//quote.eastmoney.com/zs" + code + ".html";
                            var zsarr = _this.getzs_info(res, code);
                            hk_html += "<tr " + (i % 2 == 1 ? "class='bbLightBlue'" : "") + ">\n                            " + (i == 1 ? '<td rowspan="2" class="bbLightBlue">' + fieldtools_1["default"].strformat(BOARD_TYPE) + '</td>' : '') + "\n                            <td><a href=\"//quote.eastmoney.com/center/list.html" + arr[i] + "\">" + name_1 + "</a></td>\n                            <td>" + getStatus(listType.status) + "</td>";
                            if (listType.status != 4) {
                                hk_html += getamtStatu_nx(item, listType) + "\n                                <td><span class=\"red\">" + fieldtools_1["default"].fieldfmt(item.f104, { num: 0 }) + "</span></td>\n                                <td>" + fieldtools_1["default"].fieldfmt(item.f106, { num: 0 }) + "</td>\n                                <td><span class=\"green\">" + fieldtools_1["default"].fieldfmt(item.f105, { num: 0 }) + "</span></td>\n                                <td clsss=\"\"><a href=\"" + zs_link + "\">" + zsarr[0] + "</a></td>\n                                <td>" + fieldtools_1["default"].fieldfmt(zsarr[1], { showcolor: true, fix: '%', num: 2 }) + "</td>\n                                </tr>\n                                ";
                            }
                            else { //休市时资金流数据置空
                                hk_html += "<td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td>-</td>\n                                    <td clsss=\"\"><a href=\"" + zs_link + "\">" + zsarr[0] + "</a></td>\n                                    <td>" + fieldtools_1["default"].fieldfmt(zsarr[1], { showcolor: true, fix: '%', num: 2 }) + "</td>\n                                    </tr>";
                            }
                        }
                    }
                    north_html += "<tr>\n                    <td colspan=\"12\" style=\"text-align: left; text-indent: 10px; color: #666;\">\n                    \u6CE8\uFF1A\u56E0\u6E2F\u4EA4\u6240\u76D8\u4E2D\u62AB\u9732\u673A\u5236\u8C03\u6574\uFF0C\u4E0D\u518D\u62AB\u9732\u6CAA\u6DF1\u80A1\u901A\u5B9E\u65F6\u4E70\u5165\u3001\u5356\u51FA\u91D1\u989D <a target=\"_blank\" href=\"https://finance.eastmoney.com/a/202404123042392578.html\">\u70B9\u51FB\u67E5\u770B\u8BE6\u60C5>></a></td>\n                    </tr>";
                    $(".hk_table").html(hk_html);
                    $(".north_table").html(north_html);
                });
            },
            error: function (err) {
                console && console.log(err);
            }
        });
    },
    getzs_info: function (res, code) {
        var name, scope;
        res === null || res === void 0 ? void 0 : res.forEach(function (item) {
            if (item.f12 == code) {
                name = item.f14;
                scope = item.f3;
                return;
            }
        });
        return [name, scope];
    },
    load_hq_scx: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this, url, data, arr, k;
            return __generator(this, function (_a) {
                _this = this;
                url = "//push2.eastmoney.com/api/qt/ulist.np/get";
                data = {
                    secids: '90.BK0707,201.HK32,90.BK0804,201.HK31,1.000001,100.HSI,0.399001',
                    fields: 'f2,f3,f4,f12,f13,f14,f104,f105,f106,f128,f136,f140',
                    fltt: 2
                };
                arr = [];
                for (k in data) {
                    arr.push(k + "=" + data[k]);
                }
                return [2 /*return*/, $.ajax({
                        type: "get",
                        url: url + "?" + arr.join("&"),
                        // url: wconfig.getWebPath('datacenter') + "api/data/v1/get",
                        dataType: "jsonp",
                        jsonp: 'cb'
                    })];
            });
        });
    },
    makedata: function (res) {
        var _a, _b, _c;
        var arr = [];
        for (var i in (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.diff) {
            arr.push((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.diff[i]);
        }
        (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.diff = arr;
        return res;
    },
    makedata_bbzj: function (res) {
        var _a, _b;
        (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.diff) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
            Object.keys(item).forEach(function (key) {
                item[mapping[key]] = item[key];
            });
        });
        return res;
    },
    load_date_tabs: function (mkt, defdate) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this, json, list, maxdate, html_1, arr, date, zdy_html;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, $.ajax({
                                url: wconfig.getWebPath('datacenter') + 'api/data/v1/get',
                                type: 'GET',
                                dataType: 'jsonp',
                                data: {
                                    reportName: 'RPT_MUTUAL_TRADEDATE',
                                    columns: 'ALL',
                                    pageNumber: 1,
                                    pageSize: 200,
                                    sortColumns: "HOLD_DATE",
                                    sortTypes: -1,
                                    source: "WEB",
                                    client: "WEB",
                                    filter: "(MUTUAL_TYPE=\"" + (mkt || 'N') + "\")"
                                }
                            })];
                    case 1:
                        json = _b.sent();
                        list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                        maxdate = '';
                        if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
                            html_1 = '';
                            arr = [1, 3, 5, 10, 30];
                            arr.map(function (item) {
                                var date = item == 1 && !fieldtools_1["default"].isEmpty(defdate) ? defdate : fieldtools_1["default"].dateformat(list[item - 1].HOLD_DATE);
                                var day = fieldtools_1["default"].dateformat(date, 'MM月DD日');
                                var tagStr = item == 1 ? day : "\u8FD1" + item + "\u65E5";
                                var isAt = item == 1 ? 'at' : '';
                                html_1 += "<li data-value=\"" + item + "\" date=\"" + date + "\" class=\"" + isAt + "\">" + tagStr + "<i></i></li>";
                            });
                            if ($('.dayTypeCont').attr('data-type')) {
                                // 动态插入位置，南向的时间模块需要特殊处理
                                $(".dayTypeCont[data-type='" + (mkt == 'S' ? 'nx' : 'bx') + "']").find('.day_type').prepend(html_1);
                            }
                            else {
                                // 北向及其他的日期情况
                                $('.day_type').prepend(html_1);
                            }
                            maxdate = moment(list[0].HOLD_DATE).format('YYYY-MM-DD');
                            date = defdate || maxdate;
                            zdy_html = "\n                <div class=\"date-input-wrap\">\n                  <input type=\"text\" class=\"date-input date-start\" readonly=\"readonly\" value=\"" + date + "\"  onclick=\"WdatePicker({minDate:'" + _this.sdate + "'})\">\n                  \u81F3\n                  <input type=\"text\" class=\"date-input date-end\" readonly=\"readonly\" value=\"" + date + "\" onclick=\"WdatePicker()\">\n                </div>\n                <div class=\"search_btn\"></div>";
                            $('.rangeDate').html(zdy_html);
                            $('.tagRange').off('click').on('click', function () {
                                $(this).parent().find('li').removeClass('at');
                                $(this).addClass('at');
                                $('.rangeDate').show();
                            });
                        }
                        return [2 /*return*/, maxdate];
                }
            });
        });
    },
    load_date_tabs_input: function (mkt, defdate) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this, json, list, maxdate, html_2, arr, date, zdy_html;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, $.ajax({
                                url: wconfig.getWebPath('datacenter') + 'api/data/v1/get',
                                type: 'GET',
                                dataType: 'jsonp',
                                data: {
                                    reportName: 'RPT_MUTUAL_TRADEDATE',
                                    columns: 'ALL',
                                    pageNumber: 1,
                                    pageSize: 200,
                                    sortColumns: "HOLD_DATE",
                                    sortTypes: -1,
                                    source: "WEB",
                                    client: "WEB",
                                    filter: "(MUTUAL_TYPE=\"" + (mkt || 'N') + "\")"
                                }
                            })];
                    case 1:
                        json = _b.sent();
                        list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                        maxdate = '';
                        if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
                            html_2 = '';
                            arr = [1, 3, 5, 10, 30];
                            arr.map(function (item) {
                                var _a;
                                var date = item == 1 && !fieldtools_1["default"].isEmpty(defdate) ? defdate : fieldtools_1["default"].dateformat((_a = list[item - 1]) === null || _a === void 0 ? void 0 : _a.HOLD_DATE);
                                var day = fieldtools_1["default"].dateformat(date, 'MM月DD日');
                                var tagStr = item == 1 ? day : "\u8FD1" + item + "\u65E5";
                                var isChecked = item == 1 ? 'checked="checked"' : '';
                                var isAt = item == 1 ? 'at' : '';
                                html_2 += "<input type=\"radio\" name=\"jjph_radio_" + (mkt == 'S' ? 'nx' : 'bx') + "\" class=\"" + isAt + "\" data-value=\"" + item + "\" date=\"" + date + "\" " + isChecked + "><label>" + tagStr + "</label><i></i></input>";
                            });
                            html_2 += "<input name=\"jjph_radio_" + (mkt == 'S' ? 'nx' : 'bx') + "\" type=\"radio\" data-value=\"-1\" class=\"tagRange\"><label>\u81EA\u5B9A\u4E49\u533A\u95F4</label><cite class=\"icon icon_faq2\" title=\"\u5728\u6307\u5B9A\u7684\u65F6\u95F4\u6BB5\u5185\uFF0C\u7EDF\u8BA1\u51FA\u4E2A\u80A1\u7684\u4E0A\u699C\u60C5\u51B5\uFF0C\u4EE5\u53CA\u4E0A\u699C\u540E\u7684\u4E2A\u80A1\u884C\u60C5\u8D70\u52BF\u3002\"></cite><i></i></input><div class=\"rangeDate_" + (mkt == 'S' ? 'nx' : 'bx') + "\" style=\"display: none;\"></div>";
                            if ($('.dayTypeCont').attr('data-type')) {
                                // 动态插入位置，南向的时间模块需要特殊处理
                                $(".dayTypeCont[data-type='" + (mkt == 'S' ? 'nx' : 'bx') + "']").find('.day_type').prepend(html_2);
                            }
                            else {
                                // 北向及其他的日期情况
                                $('.day_type').prepend(html_2);
                            }
                            maxdate = moment(list[0].HOLD_DATE).format('YYYY-MM-DD');
                            date = defdate || maxdate;
                            zdy_html = "\n                <div class=\"date-input-wrap\">\n                  <input type=\"text\" class=\"date-input date-start\" readonly=\"readonly\" value=\"" + date + "\"  onclick=\"WdatePicker({minDate:'" + _this.sdate + "'})\">\n                  \u81F3\n                  <input type=\"text\" class=\"date-input date-end\" readonly=\"readonly\" value=\"" + date + "\" onclick=\"WdatePicker()\">\n                </div>\n                <div class=\"search_btn\"></div>";
                            $('.rangeDate_nx').html(zdy_html);
                            $('.rangeDate_bx').html(zdy_html);
                            $('.tagRange').off('click').on('click', function () {
                                $(this).parent().find('li').removeClass('at');
                                $(this).addClass('at');
                                $(".rangeDate_nx").show();
                                $(".rangeDate_bx").show();
                            });
                        }
                        return [2 /*return*/, maxdate];
                }
            });
        });
    },
    getNextDate: function (date, day) {
        if (!day) {
            return date;
        }
        if (day == "M" || day == "Q") {
            var x = day == "M" ? 1 : 3;
            var currentDate = new Date(date);
            var previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - x, currentDate.getDate());
            var year = previousMonth.getFullYear();
            var month = String(previousMonth.getMonth() + 1).padStart(2, "0");
            var daye = String(previousMonth.getDate()).padStart(2, "0");
            return year + "-" + month + "-" + daye;
        }
        if (day == "Y") {
            var currentDate = new Date(date);
            var previousYear = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());
            var year = previousYear.getFullYear();
            var month = String(previousYear.getMonth() + 1).padStart(2, "0");
            var daye = String(previousYear.getDate()).padStart(2, "0");
            return year + "-" + month + "-" + daye;
        }
        var currentDate = new Date(date);
        var previousNDays = new Date(currentDate.getTime() - (Number(day) * 24 * 60 * 60 * 1000));
        var year = previousNDays.getFullYear();
        var month = String(previousNDays.getMonth() + 1).padStart(2, "0");
        var daye = String(previousNDays.getDate()).padStart(2, "0");
        return year + "-" + month + "-" + daye;
    },
    getbkdata: function (code, key) {
        key = key || "f62";
        return $.ajax({
            url: webconfig.getWebPath("url") + "/dataapi/bkzj/getbkzj",
            type: 'GET',
            data: {
                key: key,
                code: code,
            },
        });
    },
    "zfb": {
        columns: {
            scode: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f12) + "\">" + item.f12 + "</a>";
                }
            },
            sname: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/stockdata/" + item.f12 + ".html\">" + fieldtools_1["default"].fmtsname(item.f14) + "</a>";
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/stockdata/" + item.f12 + ".html\">\u6570\u636E</a> <a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f12) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/topic," + item.f12 + ".html\">\u80A1\u5427</a>";
                }
            },
            scode_hk: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f12) + "\">" + item.f12 + "</a>";
                }
            },
            sname_hk: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f12) + "\">" + item.f14 + "</a>";
                }
            },
            xg_hk: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.f12) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/hk/list,hk" + item.f12 + ".html\">\u80A1\u5427</a>";
                }
            },
            zxj: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f2, { num: item.f1, showcolor: true, colorvalue: item.f3 });
                }
            },
            zdf: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f3, { showcolor: true, num: item.f152, fix: '%' });
                }
            },
            cje: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f6, { num: 2 });
                }
            },
            hsl: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f8, { omit: false, num: 2, fix: '%' });
                }
            },
            syl: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f9, { num: item.f152 });
                }
            },
            zsz: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f20, { num: 2 });
                }
            },
            g_gb: {
                formatter: function (value, item, i, field) {
                    return '<a href="//guba.eastmoney.com/hk/list,hk' + item.f12 + '.html" target="_blank">港股吧</a>';
                }
            },
            a_code: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].strformat(item.f191);
                }
            },
            a_zxj: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f186, { showcolor: true, colorvalue: item.f187, num: item.f190 });
                }
            },
            a_zdf: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.f187, { num: item.f152, fix: '%', showcolor: true });
                }
            },
            a_gb: {
                formatter: function (value, item, i, field) {
                    return '<a href="//guba.eastmoney.com/topic,' + item.f191 + '.html" target="_blank">A股吧</a>';
                }
            },
            ah_bj: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].strformat(item.f189);
                }
            },
            ah_yj: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].strformat(item.f188);
                }
            }
        }
    },
    "top10": {
        columns: {
            RANK: {
                formatter: function (value, item, i, field) {
                    return value;
                    // return item.MarketType == 4 ? item.Rank1 : item.Rank;
                }
            },
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") {
                        return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) + "\">" + value + "</a>";
                    }
                    else {
                        return '<a href="/stockdata/' + item.SECURITY_CODE + '.html">' + fieldtools_1["default"].fmtsname(value) + '</a>';
                    }
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") {
                        return "<a href=\"/hsgt/" + item.SECURITY_CODE + ".html\" class=\"red\">\u6210\u4EA4\u699C</a> <a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/list,hk" + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                    }
                    else {
                        return "<a href=\"/hsgt/" + item.SECURITY_CODE + ".html\" class=\"red\">\u6210\u4EA4\u699C</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a> <a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/list," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                    }
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, fix: '%', num: 2 });
                }
            },
            NET_BUY_AMT: {
                formatter: { num: 2, showcolor: true }
            },
            BUY_AMT: {
                formatter: { num: 2 }
            },
            SELL_AMT: {
                formatter: { num: 2 }
            },
            DEAL_AMT: {
                formatter: { num: 2 }
            },
            TRADE_DATE: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    return "<a href=\"/hsgt/top10/" + date + ".html\">" + date + "</a>";
                }
            },
            cgmx: {
                formatter: function (value, item, i, field) {
                    // 南向
                    if ((stockInfo === null || stockInfo === void 0 ? void 0 : stockInfo.market) == 116) {
                        return "<a class=\"red\" href=\"/hsgt/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u6301\u80A1\u660E\u7EC6</a>";
                    }
                    return "<a class=\"red\" href=\"/hsgtV2/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u6301\u80A1\u660E\u7EC6</a>";
                }
            },
            date_nolink: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].dateformat(item.TRADE_DATE);
                }
            },
            list_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") {
                        return "<a href=\"/hsgt/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/list," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                    }
                    else {
                        return "<a href=\"/hsgt/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/zjlx/" + item.SECURITY_CODE + ".html\">\u8D44\u91D1\u6D41</a> <a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) + "\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/list," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                    }
                }
            }
        }
    },
    "ggph": {
        columns: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: emfield.name,
            xg: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgt/StockHdDetail/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>";
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_SHARES: {
                formatter: { zoom: 4, num: 2 }
            },
            HOLD_MCAP_CHANGE: {
                formatter: { zoom: 4, num: 2 }
            },
            HOLD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2 }
            },
            FREE_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    // let zb = item.Market == "001" ? item.SharesRate : item.LTZB * 100;
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            TOTAL_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    // let zb = item.Market == "001" ? item.ZZB * 100 : item.SharesRate;
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            ADD_SHARES_REPAIR: {
                formatter: { zoom: 4, num: 2 }
            },
            ADD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2, showcolor: true }
            },
            ADD_SHARES_AMP: {
                formatter: { num: 2, fix: '%', showcolor: true }
            },
            FREECAP_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            TOTAL_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            INDUSTRY_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/" + item.INDUSTRY_CODE_NEW + ".html\">" + item["INDUSTRY_NAME"] + "</a>";
                }
            },
            TRADE_DATE: emfield.date,
            gg_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MARKET == "S") {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a>"; //港股没有数据页
                    }
                    else {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>"; //相关
                    }
                }
            },
            HOLD_MARKETCAP_CHG1: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG5: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG10: emfield.num_trim_end_c
        }
    },
    "ggph_old": {
        columns: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: emfield.name,
            xg: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>";
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_SHARES: {
                formatter: { zoom: 4, num: 2 }
            },
            HOLD_MCAP_CHANGE: {
                formatter: { zoom: 4, num: 2 }
            },
            HOLD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2 }
            },
            FREE_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    // let zb = item.Market == "001" ? item.SharesRate : item.LTZB * 100;
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            TOTAL_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    // let zb = item.Market == "001" ? item.ZZB * 100 : item.SharesRate;
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            ADD_SHARES_REPAIR: {
                formatter: { zoom: 4, num: 2 }
            },
            ADD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2, showcolor: true }
            },
            ADD_SHARES_AMP: {
                formatter: { num: 2, fix: '%', showcolor: true }
            },
            FREECAP_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            TOTAL_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            INDUSTRY_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/" + item.INDUSTRY_CODE_NEW + ".html\">" + item["INDUSTRY_NAME"] + "</a>";
                }
            },
            TRADE_DATE: emfield.date,
            gg_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MARKET == "S") {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a>"; //港股没有数据页
                    }
                    else {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>"; //相关
                    }
                }
            },
            HOLD_MARKETCAP_CHG1: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG5: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG10: emfield.num_trim_end_c
        }
    },
    "ggph_bx": {
        columns: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: emfield.name,
            xg: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgtV2/StockHdDetail/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>";
                }
            },
            SECURITY_NAME_ABBR: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    if (item.SECURITY_TYPE_CODE == "058001005") //三板
                        return fieldtools_1["default"].fmtsname(item.SECURITY_NAME_ABBR);
                    return "<a href=\"/stockdata/" + c + ".html\">" + fieldtools_1["default"].fmtsname(item.SECURITY_NAME_ABBR) + "</a>";
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_SHARES: {
                formatter: { zoom: 0, num: 2 }
            },
            HOLD_MCAP_CHANGE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, zoom: 4, num: 2 });
                }
            },
            ADD_SHARES_REPAIR: {
                formatter: { zoom: 4, num: 2 }
            },
            ADD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2, showcolor: true }
            },
            ADD_SHARES_AMP: {
                formatter: { num: 2, fix: '%', showcolor: true }
            },
            FREECAP_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            TOTAL_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            INDUSTRY_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/" + item.INDUSTRY_CODE_NEW + ".html\">" + item["INDUSTRY_NAME"] + "</a>";
                }
            },
            TRADE_DATE: emfield.date,
            gg_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MARKET == "S") {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a>"; //港股没有数据页
                    }
                    else {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>"; //相关
                    }
                }
            },
            HOLD_SHARES_LAST: {
                formatter: { zoom: 0, num: 2 }
            },
            HOLD_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            ORG_QUANTITY_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_MARKET_CAP: {
                formatter: { zoom: 0, num: 2 }
            },
            FREE_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            TOTAL_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            INDUSTRY_NAME: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgtV2/" + item.BOARD_CODE + ".html\">" + item.INDUSTRY_NAME + "</a>";
                }
            },
            BOARD_NAME: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgtV2/" + item.BOARD_CODE + ".html\">" + item.BOARD_NAME + "</a>";
                }
            },
            HOLD_MARKETCAP_CHG1: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG5: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG10: emfield.num_trim_end_c
        }
    },
    "ggph_bx_ls": {
        columns: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: emfield.name,
            xg: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgt/StockHdDetail/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>";
                }
            },
            SECURITY_NAME_ABBR: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    if (item.SECURITY_TYPE_CODE == "058001005") //三板
                        return fieldtools_1["default"].fmtsname(item.SECURITY_NAME_ABBR);
                    return "<a href=\"/stockdata/" + c + ".html\">" + fieldtools_1["default"].fmtsname(item.SECURITY_NAME_ABBR) + "</a>";
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_SHARES: {
                formatter: { zoom: 4, num: 2 }
            },
            HOLD_MCAP_CHANGE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, zoom: 4, num: 2 });
                }
            },
            ADD_SHARES_REPAIR: {
                formatter: { zoom: 4, num: 2 }
            },
            ADD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2, showcolor: true }
            },
            ADD_SHARES_AMP: {
                formatter: { num: 2, fix: '%', showcolor: true }
            },
            FREECAP_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            TOTAL_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            INDUSTRY_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/" + item.INDUSTRY_CODE_NEW + ".html\">" + item["INDUSTRY_NAME"] + "</a>";
                }
            },
            TRADE_DATE: emfield.date,
            gg_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MARKET == "S") {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a>"; //港股没有数据页
                    }
                    else {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>"; //相关
                    }
                }
            },
            HOLD_SHARES_LAST: {
                formatter: { num: 2 }
            },
            HOLD_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            ORG_QUANTITY_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2 }
            },
            FREE_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            TOTAL_SHARES_RATIO: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            INDUSTRY_NAME: {
                formatter: function (value, item, i, field) {
                    var code = item.SCode;
                    return "<a href=\"/hsgtV2/" + item.BOARD_CODE + ".html\">" + item.INDUSTRY_NAME + "</a>";
                }
            },
            HOLD_MARKETCAP_CHG1: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG5: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG10: emfield.num_trim_end_c
        }
    },
    "ggph_nx": {
        columns: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    var hk = (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") ? true : false;
                    var hqLink = hk ? "//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) : "/stockdata/" + item.SECURITY_CODE + ".html";
                    return "<a href=\"" + hqLink + "\">" + (hk ? value : fieldtools_1["default"].fmtsname(value)) + "</a>";
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>";
                }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2 });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true, num: 2, fix: "%" }
            },
            HOLD_SHARES: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") { //南向原始数据，北向以万为单位
                        return fieldtools_1["default"].fieldfmt(value, { num: 2 });
                    }
                    else {
                        return fieldtools_1["default"].fieldfmt(value, { zoom: 4, num: 2 });
                    }
                }
            },
            HOLD_MARKET_CAP: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") { //南向原始数据，北向以万为单位
                        return fieldtools_1["default"].fieldfmt(value, { num: 2 });
                    }
                    else {
                        return fieldtools_1["default"].fieldfmt(value, { zoom: 4, num: 2 });
                    }
                }
            },
            FREE_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            TOTAL_SHARES_RATIO: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { fix: "%" });
                }
            },
            ADD_SHARES_REPAIR: {
                formatter: { zoom: 4, num: 2 } //北向是万为单位
            },
            ADD_MARKET_CAP: {
                formatter: { zoom: 4, num: 2, showcolor: true }
            },
            ADD_SHARES_AMP: {
                formatter: { num: 2, fix: '%', showcolor: true }
            },
            FREECAP_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            TOTAL_RATIO_CHG: {
                formatter: { num: 2, fix: '‰', showcolor: true }
            },
            INDUSTRY_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/hsgtcg/" + (item.INDUSTRY_CODE_NEW || item.NEW_CONCEPT_CODE || item.AREA_CODE_NEW) + ".html\">" + item["INDUSTRY_NAME"] + "</a>";
                }
            },
            gg_xg: {
                formatter: function (value, item, i, field) {
                    if (item.MUTUAL_TYPE == "002" || item.MUTUAL_TYPE == "004") {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a>"; //港股没有数据页
                    }
                    else {
                        return "<a class=\"red\" href=\"/hsgtcg/StockHdDetail/" + item.SECURITY_CODE + "/" + fieldtools_1["default"].dateformat(item.TRADE_DATE) + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>"; //相关
                    }
                }
            },
            HOLD_MARKETCAP_CHG1: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG5: emfield.num_trim_end_c,
            HOLD_MARKETCAP_CHG10: emfield.num_trim_end_c,
            TRADE_DATE: emfield.date,
            zdf: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.CHANGE_RATE, { showcolor: true, num: 2 });
                }
            },
            cgzb: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.TOTAL_SHARES_RATIO, { omit: false });
                }
            },
            A_SHARES_RATIO: emfield.bfb,
            HOLD_SHARES_RATIO: emfield.bfb
        }
    },
    "ggcgmx": {
        columns: {
            HOLD_DATE: emfield.date,
            TRADE_DATE: emfield.date,
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { num: 2, showcolor: true, colorvalue: item.CHANGE_RATE });
                }
            },
            CHANGE_RATE: {
                formatter: { num: 2, showcolor: true }
            },
            jgmc: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis w178\" href=\"/hsgtcg/InstitutionHdStatistics/" + item.PARTICIPANT_CODE + ".html\" title=\"" + item.ORG_NAME + "\">" + fieldtools_1["default"].cutstr(item.ORG_NAME, 20) + "</a>";
                }
            },
            jgmc_etf: {
                formatter: function (value, item, i, field) {
                    // return `<a class="ellipsis w178" href="/hsgtcg/InstitutionHdStatistics/${item.PARTICIPANT_CODE}.html" title="${item.HOLD_ORG_NAME}">${fieldtools.cutstr(item.HOLD_ORG_NAME, 20)}</a>`;
                    return "<span class=\"ellipsis w178\" title=\"" + item.HOLD_ORG_NAME + "\">" + fieldtools_1["default"].cutstr(item.HOLD_ORG_NAME, 20) + "</span>";
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/hsgt/StockInstitutionDetail/" + item.SECURITY_CODE + "-" + item.PARTICIPANT_CODE + ".html\">\u66F4\u591A</a>"; //相关
                }
            },
            HOLD_NUM: emfield.num_trim_end,
            HOLD_SHARES: emfield.num_trim_end,
            HOLD_MARKET_CAP: emfield.num_trim_end,
            HOLD_SHARES_RATIO: emfield.bfb,
            HOLD_MARKET_CAPONE: emfield.num_trim_end_c,
            HOLD_MARKET_CAPFIVE: emfield.num_trim_end_c,
            HOLD_MARKET_CAPTEN: emfield.num_trim_end_c,
            SECURITY_CODE: emfield.code,
            SECURITY_NAME_ABBR: {
                formatter: function (value, item, i, field) {
                    var hk = item.MARKET_CODE == "S" ? true : false;
                    var hqLink = hk ? "//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SECURITY_CODE) : "/stockdata/" + item.SECURITY_CODE + ".html";
                    return "<a href=\"" + hqLink + "\">" + (hk ? value : fieldtools_1["default"].fmtsname(value)) + "</a>";
                }
            },
            ORG_NAME: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis w178\" href=\"/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + fieldtools_1["default"].dateformat(item.HOLD_DATE) + ".html\" title=\"" + item.ORG_NAME + "\">" + fieldtools_1["default"].cutstr(item.ORG_NAME, 20) + "</a>";
                }
            },
            jg_xg: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/hsgtcg/StockInstitutionDetail/" + item.SECURITY_CODE + "-" + item.PARTICIPANT_CODE + ".html\">\u66F4\u591A</a>&nbsp;&nbsp;&nbsp;\n                    <a href=\"/hsgtcg/StockHdStatistics/" + item.SECURITY_CODE + ".html\">\u4E2A\u80A1\u6301\u80A1</a>"; //相关
                }
            }
        }
    },
    "bbzj": {
        columns: {
            "f12": {
                formatter: function (value, item, i, field) {
                    if (item.f13 != undefined)
                        return "<a href=\"//quote.eastmoney.com/unify/r/" + item.f13 + "." + value + "\">" + value + "</a>";
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(value) + "\">" + value + "</a>";
                }
            },
            "f14": {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/stockdata/" + item.f12 + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            },
            "name_bk": {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/90." + item.f12 + "\">" + item.f14 + "</a>";
                }
            },
            "ssbk": {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/bkzj/" + item.f265 + ".html\">" + item.f100 + "</a>";
                }
            },
            "xg_bk": {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/bkzj/" + item.f12 + ".html\">\u5927\u5355\u8BE6\u60C5</a>&nbsp;\n                    <a href=\"//guba.eastmoney.com/list," + item.f12 + ".html\">\u80A1\u5427</a>";
                }
            },
            "xg_gg": {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/zjlx/" + item.f12 + ".html\">\u8BE6\u60C5</a>&nbsp;\n                    <a href=\"/stockdata/" + item.f12 + ".html\">\u6570\u636E</a>&nbsp;\n                    <a href=\"//guba.eastmoney.com/list," + item.f12 + ".html\">\u80A1\u5427</a>&nbsp;\n                    <a href=\"/report/" + item.f12 + ".html\">\u7814\u62A5</a>";
                }
            },
            "xg_ggd": {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/zjlx/" + item.f12 + ".html\">\u8BE6\u60C5</a>&nbsp;\n                    <a href=\"/stockdata/" + item.f12 + ".html\">\u6570\u636E</a>&nbsp;\n                    <a href=\"//guba.eastmoney.com/list," + item.f12 + ".html\">\u80A1\u5427</a>";
                }
            },
            "f2": {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { num: item.f1 || 2, omit: false, trim: false, showcolor: true, colorvalue: item.f3 });
                }
            },
            "zdf": emfield.bfb2_c,
            "zlje": emfield.num2_c,
            "zljzb": emfield.bfb2_c,
            "cddje": emfield.num2_c,
            "cddjzb": emfield.bfb2_c,
            "ddje": emfield.num2_c,
            "ddjzb": emfield.bfb2_c,
            "zdje": emfield.num2_c,
            "zdjzb": emfield.bfb2_c,
            "xdje": emfield.num2_c,
            "xdjzb": emfield.bfb2_c,
            "f3": emfield.bfb2_c,
            "f109": emfield.bfb2_c,
            "f160": emfield.bfb2_c,
            "f225": emfield.string,
            "f263": emfield.string,
            "f264": emfield.string,
            "f184": emfield.bfb2_c,
            "f165": emfield.bfb2_c,
            "f175": emfield.bfb2_c,
            "zdname": {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].isEmpty(item.zdcode) ? '-' : "<a href=\"/zjlx/" + item.zdcode + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                },
            }
        },
    },
    "bkph": {
        columns: {
            BOARD_NAME: {
                formatter: function (value, item, i, field) {
                    return '<a href="//quote.eastmoney.com/center/boardlist.html#boards-' + item.SECURITY_CODE + '">' + value + '</a>';
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return '<a href="/hsgtcg/' + item.SECURITY_CODE + '.html" class="red">详细</a> <a href="//guba.eastmoney.com/list,' + item.SECURITY_CODE + '.html">股吧</a>';
                }
            },
            INDEX_CHANGE_RATIO: {
                formatter: { showcolor: true, fix: '%' }
            },
            HK_VALUE: emfield.num_trim_end,
            HK_BOARD_RATIO: {
                formatter: { zoom: 2, num: 2, fix: '%' }
            },
            BOARD_HK_RATIO: {
                formatter: { zoom: 2, num: 2, fix: '%' }
            },
            ADD_MARKET_CAP: emfield.num_trim_end_c,
            ADD_RATIO: {
                formatter: { showcolor: true, fix: '%' }
            },
            ADD_BOARD_RATIO: {
                formatter: { showcolor: true, zoom: 3, fix: "‰" }
            },
            ADD_HK_RATIO: {
                formatter: { showcolor: true, zoom: 3, fix: "‰" }
            },
            MAXADD_SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].isEmpty(item.MAXADD_SECURITY_CODE) ? '' : "<a href=\"/hsgt/StockHdDetail/" + item.MAXADD_SECURITY_CODE + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            },
            MAXADD_RATIO_SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].isEmpty(item.MAXADD_RATIO_SECURITY_CODE) ? '' : "<a href=\"/hsgt/StockHdDetail/" + item.MAXADD_RATIO_SECURITY_CODE + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            },
            MINADD_SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].isEmpty(item.MINADD_SECURITY_CODE) ? '' : "<a href=\"/hsgt/StockHdDetail/" + item.MINADD_SECURITY_CODE + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            },
            MINADD_RATIO_SECURITY_NAME: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].isEmpty(item.MINADD_RATIO_SECURITY_CODE) ? '' : "<a href=\"/hsgt/StockHdDetail/" + item.MINADD_RATIO_SECURITY_CODE + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            }
        }
    },
    "bkph_new": {
        columns: {
            BOARD_NAME: {
                formatter: function (value, item, i, field) {
                    return '<a href="//quote.eastmoney.com/center/boardlist.html#boards-' + item.BOARD_CODE + '">' + value + '</a>';
                }
            },
            HOLD_ORG_NAME: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    var url = "/hsgtV2/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="ellipsis w258" href="' + url + '" title="' + item.HOLD_ORG_NAME + '">' + item.HOLD_ORG_NAME + '</a>'; //机构名称
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return '<a href="/hsgtV2/' + item.BOARD_CODE + '.html" class="red">详细</a> <a href="//guba.eastmoney.com/list,' + item.BOARD_CODE + '.html">股吧</a>';
                }
            },
            xg_jgph: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    var url = "/hsgtV2/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="red" href="' + url + '">详细</a>';
                }
            },
            CHANGE_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            HOLD_SHARES: {
                formatter: { num: 2 }
            },
            HOLD_SHARES_LAST: {
                formatter: { num: 2 }
            },
            HOLD_SHARES_RATIO: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            COMPOSITION_QUANTITY_RATIO: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            HOLD_MARKET_CAP: {
                formatter: { num: 2 }
            },
            HOLD_MARKET_CAP_LAST: {
                formatter: { num: 2 }
            },
            ADD_SHARES_AMP: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            MAXHOLD_NAME: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.MAXHOLD_SECUCODE) + "\">" + item.MAXHOLD_NAME + "</a>";
                }
            },
            MAXHOLD_CAP: {
                formatter: { num: 2 }
            }
        }
    },
    "lssj": {
        columns: {
            TRADE_DATE: emfield.date,
            NET_DEAL_AMT: {
                formatter: { zoom: 6, num: 2, showcolor: true, fix: '元' }
            },
            BUY_AMT: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            SELL_AMT: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            ACCUM_DEAL_AMT: {
                formatter: { zoom: 6, num: 2, showcolor: true, fix: '元' }
            },
            FUND_INFLOW: {
                formatter: { zoom: 6, num: 2, showcolor: true, fix: '元' }
            },
            QUOTA_BALANCE: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            HOLD_MARKET_CAP: {
                formatter: function (value, item, i, field) {
                    return value != 0 ? fieldtools_1["default"].fieldfmt(value, { num: 2, fix: '元' }) : "-";
                }
                // formatter: { num: 2, fix: '元' }
            },
            LEAD_STOCKS_NAME: {
                formatter: function (value, item, i, field) {
                    return value ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.LEAD_STOCKS_CODE) + "\">" + (item.LEAD_STOCKS_CODE.split(".")[1] == "HK" ? value : fieldtools_1["default"].fmtsname(value)) + "</a>" : "-";
                }
            },
            LS_CHANGE_RATE: emfield.bfb2_c,
            INDEX_CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { omit: false, num: 2, showcolor: true, colorvalue: item.INDEX_CHANGE_RATE });
                }
            },
            INDEX_CHANGE_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            }
        }
    },
    "lssj_bx": {
        columns: {
            TRADE_DATE: emfield.date,
            NF_DEAL_AMT: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            SSC_DEAL_AMT: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            SSC_CHANGE_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            SSC_LEAD_STOCKS: {
                formatter: function (value, item, i, field) {
                    return value ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.SSC_LEAD_STOCKSCODE) + "\">" + (item.SSC_LEAD_STOCKSCODE.split(".")[1] == "HK" ? value : fieldtools_1["default"].fmtsname(value)) + "</a>" : "-";
                }
            },
            SCI_INDEX_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { omit: false, num: 2, showcolor: true, colorvalue: item.SCI_INDEX_RATE });
                }
            },
            SCI_INDEX_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            ST_DEAL_AMT: {
                formatter: { zoom: 6, num: 2, fix: '元' }
            },
            ST_CHANGE_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            ST_LEAD_STOCKS: {
                formatter: function (value, item, i, field) {
                    return value ? "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.ST_LEAD_STOCKSCODE) + "\">" + (item.ST_LEAD_STOCKSCODE.split(".")[1] == "HK" ? value : fieldtools_1["default"].fmtsname(value)) + "</a>" : "-";
                }
            },
            SZC_INDEX_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { omit: false, num: 2, showcolor: true, colorvalue: item.SZC_INDEX_RATE });
                }
            },
            SZC_INDEX_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
        }
    },
    "jgph": {
        columns: {
            HOLD_DATE: emfield.date,
            ORG_NAME: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.HOLD_DATE);
                    var url = "/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="ellipsis w258" href="' + url + '" title="' + item.ORG_NAME + '">' + item.ORG_NAME + '</a>'; //机构名称
                }
            },
            jgmc: {
                formatter: function (value, item, i, field) {
                    return "<span title=\"" + fieldtools_1["default"].strformat(item.ORG_NAME) + "\">" + fieldtools_1["default"].cutstr(item.ORG_NAME, 28) + "</span>"; //机构名称不加链接
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.HOLD_DATE);
                    var url = "/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="red" href="' + url + '">详细</a>';
                }
            },
            HOLD_NUM: {
                formatter: { num: 0, omit: false }
            },
            HOLD_MARKET_CAP: emfield.num_trim_end,
            HOLD_MARKET_CAPONE: emfield.num_trim_end_c,
            HOLD_MARKET_CAPFIVE: emfield.num_trim_end_c,
            HOLD_MARKET_CAPTEN: emfield.num_trim_end_c
        }
    },
    drawchart_fs: function (chart, times, data_series) {
        var echart = echarts.init(document.getElementById(chart));
        var x_points = ["9:30", "10:30", "11:30", "14:00", "15:00"];
        if (chart.split("_")[0] == "south") {
            x_points = ["9:30", "11:00", "13:30", "14:30", "16:00"];
        }
        var option = {
            tooltip: {
                confine: true,
                trigger: 'axis',
                formatter: function (data) {
                    var str = "";
                    var date = data[0].axisValue;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].value) {
                            str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2, fix: "亿元" }) + '<br/>';
                        }
                    }
                    return date + '<br/>' + str;
                }
            },
            legend: {
                right: 20,
                show: false
            },
            grid: {
                top: '15',
                left: '3%',
                right: '20',
                bottom: '10',
                containLabel: true
            },
            xAxis: [{
                    type: 'category',
                    data: times,
                    axisTick: { show: false },
                    boundaryGap: false,
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        interval: function (index, value) {
                            return x_points.indexOf(value) > -1;
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                },
                {
                    type: 'category',
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }],
            yAxis: [
                {
                    type: 'value',
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 1
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        formatter: function (value, index) {
                            return value.toFixed(2);
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                },
                {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }
            ],
            series: data_series
        };
        echart.setOption(option);
    },
    drawchart_fs_hsgtDetail: function (chart, times, data_series, type) {
        var echart = echarts.init(document.getElementById(chart));
        echart.clear();
        var x_points = ["9:30", "10:30", "11:30", "14:00", "15:00"];
        if (type == "south") {
            x_points = ["9:30", "11:00", "13:30", "14:30", "16:00"];
        }
        var option = {
            tooltip: {
                confine: true,
                trigger: 'axis',
                formatter: function (data) {
                    var str = "";
                    var date = data[0].axisValue;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].value) {
                            str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2, fix: "亿元" }) + '<br/>';
                        }
                    }
                    return date + '<br/>' + str;
                }
            },
            legend: {
                right: 20,
                show: false
            },
            grid: {
                top: '15',
                left: '5',
                right: '20',
                bottom: '10',
                containLabel: true
            },
            xAxis: [{
                    type: 'category',
                    data: times,
                    axisTick: { show: false },
                    boundaryGap: false,
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        interval: function (index, value) {
                            return x_points.indexOf(value) > -1;
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                },
                {
                    type: 'category',
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }],
            yAxis: [
                {
                    type: 'value',
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 1
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        formatter: function (value, index) {
                            return fieldtools_1["default"].fieldfmt(value, { num: 1, trim: true });
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                },
                {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }
            ],
            series: data_series
        };
        echart.setOption(option);
    },
    drawchart_ls: function (chart, xdata, ydata) {
        var echart = echarts.init(document.getElementById(chart));
        var option = {
            tooltip: {
                confine: true,
                trigger: 'axis',
                formatter: function (data) {
                    var str = "";
                    var date = data[0].axisValue;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].value) {
                            str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2, fix: "亿元" }) + '<br/>';
                        }
                    }
                    return date + '<br/>' + str;
                }
            },
            legend: {
                right: 20,
                show: false
            },
            grid: {
                top: '15',
                left: '5',
                right: '20',
                bottom: '10',
                containLabel: true
            },
            xAxis: [{
                    type: 'category',
                    data: xdata,
                    boundaryGap: false,
                    axisTick: { show: false },
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        showMaxLabel: true,
                        formatter: function (value, index) {
                            return fieldtools_1["default"].dateformat(value, "YYYY") + "\n" + fieldtools_1["default"].dateformat(value, "MM-DD");
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                }, {
                    type: 'category',
                    axisLine: {
                        onZero: false,
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }],
            yAxis: [
                {
                    type: 'value',
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 1
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        },
                        formatter: function (value, index) {
                            return fieldtools_1["default"].fieldfmt(value, { num: 1, trim: true });
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#dde9f3"
                        }
                    }
                },
                {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: "#999"
                        }
                    }
                }
            ],
            series: ydata
        };
        echart.setOption(option);
    },
    tooltipformatter_1: function (data) {
        var str = "";
        var date = data[0].axisValue;
        var linecount = 1;
        if (data.length > 20)
            linecount = 5;
        for (var i = 0; i < data.length; i++) {
            if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                str += data[i].marker + '<span style ="display:inline-block;width:195px;" >' + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2 }) + '</span>' + ((i + 1) % linecount == 0 ? '<br/>' : '&nbsp;');
            }
        }
        return date + '<br/>' + str;
    },
    tooltipformatter_2: function (data) {
        var str = "";
        var date = data[0].axisValue;
        var linecount = 1;
        if (data.length > 20)
            linecount = 5;
        for (var i = 0; i < data.length; i++) {
            if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                str += data[i].marker + '<span style ="display:inline-block;width:195px;" >' + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 3 }) + '</span>' + ((i + 1) % linecount == 0 ? '<br/>' : '&nbsp;');
            }
        }
        return date + '<br/>' + str;
    },
    drawchart_bk: function (chart, xdata, ydata, type) {
        var chart = echarts.init(document.getElementById(chart));
        chart.clear();
        var option = {
            tooltip: {
                trigger: 'axis',
                formatter: function (data) {
                    var str = "";
                    var date = data[0].axisValue;
                    var linecount = 1;
                    if (data.length > 20)
                        linecount = 5;
                    for (var i = 0; i < data.length; i++) {
                        if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                            var num = type == "ADD_MARKET_CAP" ? 2 : 3;
                            str += data[i].marker + '<span style ="display:inline-block;width:195px;" >' + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: num }) + '</span>' + ((i + 1) % linecount == 0 ? '<br/>' : '&nbsp;');
                        }
                    }
                    return date + '<br/>' + str;
                }
            },
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    endValue: 35,
                    zoomLock: true
                }
            ],
            legend: {
                show: false
            },
            grid: {
                left: 50,
                right: 10,
                top: 33,
                bottom: 100
            },
            xAxis: {
                type: 'category',
                triggerEvent: true,
                data: xdata,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    interval: 0,
                    textStyle: {
                        color: '#00298F'
                    },
                    formatter: function (value) {
                        var str = value.split("");
                        return str.join("\n");
                    }
                }
            },
            yAxis: [
                {
                    name: '单位(' + (type == "ADD_MARKET_CAP" ? '元' : '‰') + ')',
                    type: 'value',
                    scale: true,
                    axisTick: { show: false },
                    axisLabel: {
                        formatter: function (value, index) {
                            var xsnum = type == "ADD_MARKET_CAP" ? 0 : 1;
                            return fieldtools_1["default"].fieldfmt(value, { num: xsnum });
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    }
                }
            ],
            series: [
                {
                    name: "数值",
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                if (params.data > 0)
                                    return "#FF3F3E";
                                else
                                    return "#06960A";
                            }
                        }
                    },
                    data: ydata
                }
            ]
        };
        chart.setOption(option);
        return chart;
    },
    drawchart_bk_new: function (chart, xdata, ydata, type) {
        var chart = echarts.init(document.getElementById(chart));
        chart.clear();
        var option = {
            tooltip: {
                trigger: 'axis',
                formatter: function (data) {
                    var str = "";
                    var date = data[0].axisValue;
                    var linecount = 1;
                    if (data.length > 20)
                        linecount = 5;
                    for (var i = 0; i < data.length; i++) {
                        if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                            var num = type == "ADD_MARKET_CAP" ? 2 : 3;
                            str += data[i].marker + '<span style ="display:inline-block;width:195px;" >' + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: num }) + '</span>' + ((i + 1) % linecount == 0 ? '<br/>' : '&nbsp;');
                        }
                    }
                    return date + '<br/>' + str;
                }
            },
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    endValue: 35,
                    zoomLock: true
                }
            ],
            legend: {
                show: false
            },
            grid: {
                left: 50,
                right: 0,
                top: 33,
                bottom: 40,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                triggerEvent: true,
                data: xdata,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    interval: 0,
                    textStyle: {
                        color: '#00298F'
                    },
                    formatter: function (value) {
                        var str = value.split("");
                        return str.join("\n");
                    }
                }
            },
            yAxis: [
                {
                    name: '单位(' + (type == "COMPOSITION_QUANTITY" ? '家' : type == "HOLD_SHARES" ? '股' : '元') + ')',
                    type: 'value',
                    scale: true,
                    axisTick: { show: false },
                    axisLabel: {
                        formatter: function (value, index) {
                            var xsnum;
                            switch (type) {
                                case "HOLD_SHARES":
                                    return fieldtools_1["default"].fieldfmt(value, { num: 1 });
                                case "COMPOSITION_QUANTITY":
                                    return value;
                                case "HOLD_MARKET_CAP":
                                    return fieldtools_1["default"].fieldfmt(value, { num: 0 });
                                default:
                                    break;
                            }
                            // let xsnum = type == "COMPOSITION_QUANTITY" ? 0 : 1;
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    }
                }
            ],
            series: [
                {
                    name: "数值",
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                if (params.data > 0)
                                    return "#FF3F3E";
                                else
                                    return "#06960A";
                            }
                        }
                    },
                    data: ydata
                }
            ]
        };
        chart.setOption(option);
        return chart;
    },
    loadbkchart: function (bk_type, date, date_filter, st_field) {
        if (date_filter === void 0) { date_filter = date_type; }
        if (st_field === void 0) { st_field = "ADD_MARKET_CAP"; }
        var _this = this;
        $.ajax({
            url: wconfig.getWebPath('datacenter') + 'api/data/v1/get',
            type: 'GET',
            dataType: 'jsonp',
            data: {
                reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_WEB',
                columns: 'ALL',
                sortColumns: st_field,
                sortTypes: -1,
                source: "WEB",
                client: "WEB",
                filter: "(BOARD_TYPE=\"" + bk_type + "\")(INTERVAL_TYPE=\"" + date_filter + "\")(TRADE_DATE='" + date + "')"
            }
        }).then(function (json) {
            var _a;
            var datas = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
            ;
            datas = datas.sort(function (a, b) {
                return b[st_field] - a[st_field];
            });
            var names = [], ydatas = [], objs = {};
            for (var i = 0; i < datas.length; i++) {
                var item = datas[i];
                names.push(item.BOARD_NAME);
                ydatas.push(isFinite(parseFloat(item[st_field])) ? (item[st_field] * (st_field == "ADD_MARKET_CAP" ? 1 : 1000)) : undefined);
                objs[item.BOARD_NAME] = item;
            }
            var bkph_chart = _this.drawchart_bk("bkph_chart", names, ydatas, st_field);
            bkph_chart.off('click');
            bkph_chart.on('click', function (params) {
                console.log('object');
                if (params.componentType == "xAxis")
                    window.open("/hsgtV2/" + objs[params.value]["SECURITY_CODE"] + ".html");
            });
        });
    },
    loadbkTable: function (bk_type, date) {
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_WEB',
                    columns: 'ALL',
                    quoteColumns: "f3~05~SECURITY_CODE~INDEX_CHANGE_RATIO",
                    quoteType: delayquote_1.hsaDelay() ? "1" : "0",
                    source: "WEB",
                    client: "WEB",
                    filter: "(BOARD_TYPE=\"" + bk_type + "\")(TRADE_DATE='" + date + "')"
                }
            },
            sortname: 'ADD_MARKET_CAP',
            urlkeyvalues: pageopt.urlkeyvalues,
            columns: pageopt["bkph"].columns,
            formatter: { strfmt: true },
            filteroptions: [
                {
                    name: "filter",
                    fieldname: "dtype",
                    filterselector: "#filter_stat",
                    filtersoptionselector: "li",
                    values: function (value) {
                        return "(INTERVAL_TYPE=\"" + value + "\")";
                    },
                    handle: function (filter, that) {
                        var val = filter.value;
                        var map = {
                            "1": "今日",
                            "3": "3日",
                            "5": "5日",
                            "10": "10日",
                            "M": "1月",
                            "Q": "1季",
                            "Y": "1年"
                        };
                        $(".stattext").html(map[val]);
                    }
                }
            ]
        };
        $("#dataview_bkph").emdataview(opt);
    },
    // 北向历史总额绘图
    drawchart_north_lsze: function (date, id) {
        $.ajax({
            type: "GET",
            url: wconfig.getWebPath('datacenter') + "/web/api/data/v1/get",
            dataType: "jsonp",
            data: {
                reportName: "RPT_MUTUAL_DEALAMT",
                columns: "TRADE_DATE,SZC_INDEX_PRICE,SZC_INDEX_RATE,NF_DEAL_AMT,NF_QUOTA_BALANCE,SSC_DEAL_AMT,SSC_LEAD_STOCKS,SSC_CHANGE_RATE,SSC_QUOTA_BALANCE,ST_DEAL_AMT,ST_LEAD_STOCKS,ST_CHANGE_RATE,ST_QUOTA_BALANCE,NF_LEAD_STOCKS,NF_CHANGE_RATE",
                filter: "(TRADE_DATE>='" + date.substring(0, 10) + "')",
                quoteColumns: '',
                pageNumber: "1",
                pageSize: '600',
                sortTypes: '-1',
                sortColumns: 'TRADE_DATE',
                source: "WEB",
                client: "WEB"
            },
            success: function (json) {
                var datas = json && json.result && json.result.data;
                if (datas) {
                    var lsDate = [], shdata = [], szdata = [], hsdata = [];
                    for (var i = 0; i < datas.length; i++) {
                        var data = datas[i];
                        lsDate[i] = fieldtools_1["default"].dateformat(data.TRADE_DATE);
                        shdata[i] = fieldtools_1["default"].fieldfmt(data.SSC_DEAL_AMT, { zoom: -2 }); //沪股通
                        szdata[i] = fieldtools_1["default"].fieldfmt(data.ST_DEAL_AMT, { zoom: -2 }); //深股通
                        hsdata[i] = fieldtools_1["default"].fieldfmt(data.NF_DEAL_AMT, { zoom: -2 }); //北向资金
                    }
                    var series = [
                        {
                            name: "沪股通",
                            data: shdata,
                            connectNulls: true,
                            symbol: "circle",
                            showSymbol: false,
                            itemStyle: {
                                color: "#FAA42A"
                            },
                            lineStyle: {
                                width: 1
                            },
                            type: 'line'
                        },
                        {
                            name: "深股通",
                            data: szdata,
                            connectNulls: true,
                            symbol: "circle",
                            showSymbol: false,
                            itemStyle: {
                                color: "#F900d3"
                            },
                            lineStyle: {
                                width: 1
                            },
                            type: 'line'
                        },
                        {
                            name: "北向资金",
                            data: hsdata,
                            connectNulls: true,
                            symbol: "circle",
                            showSymbol: false,
                            itemStyle: {
                                color: "#3381e3"
                            },
                            lineStyle: {
                                width: 1
                            },
                            type: 'line'
                        },
                    ];
                    pageopt.drawchart_ls(id, lsDate, series);
                }
                ;
            }
        });
    }
};
window.pageopt = pageopt;
exports["default"] = pageopt;
